import { createApi } from '@reduxjs/toolkit/query/react'
import { CHATTER_LESSON_LIST, CHATTER_LESSON_DELETE, CHATTER_LESSON_CREATE, CHATTER_LESSON_DETAILS, CHATTER_LESSSON_EDIT } from "config/apiPaths"
import { CHATTER_LESSON_TAGS } from 'config/paths';
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const chatterLessonApi = createApi({
    reducerPath: 'chatterLessonApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/lessons",
    }),
    tagTypes: ["ChatterLesson", "ChatterLessonDetails"],
    endpoints: (builder) => ({

        // get lesson list
        getChatterLessonList: builder.query({
            query: ({ search = "", status = "", page = 1, limit = 10, tag_id, sort = { column: "id", direction: "ASC" } }) => ({
                method: "PATCH",
                url: CHATTER_LESSON_LIST,
                data: { search, status, page, limit, sort, tag_id: tag_id?.length ? tag_id : [] },
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["ChatterLesson"]
        }),

        // create chatter lesson
        createChatterLesson: builder.mutation({
            query: (data) => ({
                method: "POST",
                url: CHATTER_LESSON_CREATE,
                data
            }),
            invalidatesTags: ["ChatterLesson"]
        }),

        // delete chatter program
        deleteChatterLesson: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${CHATTER_LESSON_DELETE}/${id}`
            }),
            invalidatesTags: ["ChatterLesson", "ChatterLessonDetails"]
        }),

        // chatter program details
        chatterLessonDetails: builder.query({
            query: (id) => ({
                method: "GET",
                url: `${CHATTER_LESSON_DETAILS}/${id}`
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["ChatterLessonDetails"]
        }),

        // update chatter lesson
        updateChatterLesson: builder.mutation({
            query: ({ data, lessonId }) => ({
                method: "PUT",
                url: `${CHATTER_LESSSON_EDIT}/${lessonId}`,
                data
            }),
            invalidatesTags: ["ChatterLesson", "ChatterLessonDetails"]
        }),

          getChatterLessonTags: builder.query({
            query: () => ({
                method: "GET",
                url: CHATTER_LESSON_TAGS,
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["ChatterLessonTags"]
        }),

    })
})

export const {
    useGetChatterLessonListQuery,
    useDeleteChatterLessonMutation,
    useCreateChatterLessonMutation,
    useChatterLessonDetailsQuery,
    useUpdateChatterLessonMutation,
    useGetChatterLessonTagsQuery
} = chatterLessonApi;